<template>
  <div class="card">
    <div class="card-header">
      <h5 class="title">Patient ID: {{ id_patient }}</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <el-tabs class="col-md-12" tab-position="left" style="height: 500px;" type="border-card" @tab-click="">
          <el-tab-pane label="Personal Data">
            <div class="col-md-12">
                <div class="row">
                  <div class="col-md-5">
                    <fg-input type="text"
                              label="Surname"
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="patient_card.surname">
                    </fg-input>
                  </div>
                  <div class="col-md-4">
                    <fg-input type="text"
                              label="Name"
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="patient_card.name">
                    </fg-input>
                  </div>
                  <div class="col-md-3">
                    <fg-input type="text"
                              label="Title"
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="patient_card.title">
                    </fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3">
                    <fg-input type="text"
                              label="PID"
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="patient_card.pid">
                    </fg-input>
                  </div>
                  <div class="col-md-2">
                    <fg-input type="text"
                              label="Birth Date"
                              :disabled="patient_card_disabled"
                              placeholder="YYYY-MM-DD"
                              v-model="patient_card.birth_date">
                    </fg-input>
                  </div>
                  <div class="col-md-2">
                    <fg-input type="number"
                              label="Age"
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="age">
                    </fg-input>
                  </div>          
                  <div class="col-md-2">
                    <fg-input type="text"
                              label="Gender"
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="patient_card.gender">
                    </fg-input>
                  </div>  
                  <div class="col-md-3">
                    <fg-input type="text"
                              label="Ethnic"
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="patient_card.race">
                    </fg-input>
                  </div>                    
                </div>

                <div class="row">
                  <div class="col-md-2">
                    <fg-input type="text"
                              label="Nationality"
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="patient_card.nationality">
                    </fg-input>
                  </div>
                  <div class="col-md-2">
                    <fg-input type="text"
                              label="Insurance Comp."
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="patient_card.insurance">
                    </fg-input>
                  </div>
                  <div class="col-md-3">
                    <fg-input type="text"
                              label="Phone"
                              :disabled="patient_card_disabled"
                              placeholder="+420 123 456 789"
                              v-model="patient_card.phone">
                    </fg-input>
                  </div>
                  <div class="col-md-5">
                    <fg-input type="text"
                              label="Email"
                              :disabled="patient_card_disabled"
                              placeholder="@"
                              v-model="patient_card.email">
                    </fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-5">
                    <fg-input type="text"
                              label="Street"
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="patient_card.street">
                    </fg-input>
                  </div>
                  <div class="col-md-3">
                    <fg-input type="text"
                              label="City"
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="patient_card.city">
                    </fg-input>
                  </div>
                  <div class="col-md-2">
                    <fg-input type="text"
                              label="ZIP"
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="patient_card.zip">
                    </fg-input>
                  </div>
                  <div class="col-md-2">
                    <fg-input type="text"
                              label="Country"
                              :disabled="patient_card_disabled"
                              placeholder=""
                              v-model="patient_card.country">
                    </fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Note</label>
                      <textarea rows="4" 
                          class="form-control border-input"
                          placeholder="Notes about Patient ..."
                          v-model="patient_card.note"
                          :disabled="patient_card_disabled"
                          >
                      </textarea>
                    </div>
                  </div>
                </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Diagnoses">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12 form-group">
                  <label>Diagnose 1</label>
                  <textarea rows="6" 
                      class="form-control border-input"
                      placeholder=""
                      v-model="patient_card.diagnose1"
                      :disabled="patient_card_disabled"
                      >
                  </textarea>
                </div>
                <div class="col-md-12 form-group">
                  <label>Diagnose 2</label>
                  <textarea rows="6" 
                      class="form-control border-input"
                      placeholder=""
                      v-model="patient_card.diagnose2"
                      :disabled="patient_card_disabled"
                      >
                  </textarea>
                </div>
              </div>
            </div>
              
          </el-tab-pane>

          <el-tab-pane label="HPO">
                  <div class="row">
                      <div class="col-4">
                              <el-input
                                v-model="searchQuery_hpo"
                                size=""
                                class="bottom_margin_10"
                                placeholder="Type to search HPO" />
                      </div>


                      <div class="col-8">
                        <p-pagination class="pull-right"
                                      v-model="pagination_hpo.currentPage"
                                      :per-page="pagination_hpo.perPage"
                                      :total="pagination_hpo.total"
                                      :pager-count=5
                                      >
                        </p-pagination>
                      </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <el-table class=""
                                ref="hpo"
                                :data="hpo_data.filter(data => !searchQuery_hpo || data.hpo_term_name.toLowerCase().includes(searchQuery_hpo.toLowerCase()))"
                                border
                                highlight-current-row
                                @current-change="handle_add_hpo"
                                style="width: 100%"
                                size="medium"
                                >
                        <el-table-column
                          prop="hpo_term_name"
                          label="HPO List"
                          min-width="180"
                          >
                          <template slot-scope="scope">
                            <span>{{ scope.row.hpo_term_name }}</span>
                          </template>
                        </el-table-column>                        
                      </el-table>
                    </div>

                    <div class="col-6">
                      <el-table class=""
                                ref="hpo"
                                :data="patient_card.hpo"
                                border
                                highlight-current-row
                                @current-change="handle_del_hpo"
                                style="width: 100%"
                                size="medium"
                                >
                        <el-table-column
                          prop="hpo_term_name"
                          label="HPO Selected"
                          min-width="180"
                          >
                          <template slot-scope="scope">
                            <span>{{ scope.row.hpo_term_name }}</span>
                          </template>
                        </el-table-column>                        
                      </el-table>
                    </div>

                    <div class="col-sm-4 pagination-info">
                      <p class="category">Showing {{from_hpo + 1}} to {{to_hpo}} of {{pagination_hpo.total}} entries</p>
                    </div>

                  </div>
          </el-tab-pane>

          <el-tab-pane label="Examinations">
            <div class="col-md-12">
              xxxxxx
            </div>
          </el-tab-pane>

          <el-tab-pane label="Family">
            <div class="col-md-12">
              xxxxxx
            </div>
          </el-tab-pane>

          <el-tab-pane label="Clin Data">
            <div class="col-md-12">
              xxxxxx
            </div>
          </el-tab-pane>

          <el-tab-pane label="Reports">
            <div class="col-md-12">
              xxxxxx
            </div>
          </el-tab-pane>

          <el-tab-pane label="Actions">
            <div class="col-md-12">
              xxxxxx
            </div>
          </el-tab-pane>

        </el-tabs>
      </div>
    </div>

    <div class="card-footer">
      <div class="row">
        <p-button native-type="button" slot="footer" type="success" block class="col-6 mb-3 ml-auto mr-auto" @click.native=""> Update Patient Data </p-button>
      </div>
    </div>    
  </div>
</template>
<script>
  import {Table, TableColumn, Select, Option, Tabs, TabPane, Tooltip, Progress } from 'element-ui';
  import PPagination from 'src/components/UIComponents/Pagination.vue';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

  export default {
    name: 'PatientCard',

    components: {
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
      PPagination,
    },

    data () {
      return {
        user: {
          company: 'NASA',
          email: 'faker@nasa.gov',
          firstName: 'Bill',
          lastName: 'Faker',
          address: 'Tampa, Florida, USA',
          city: 'Tampa',
          postalCode: '',
          aboutMe: `But that's the difference in our opinions.`
        },
        age: 99,

        searchQuery_hpo: "",

        pagination_hpo: {
          perPage: 12,
          currentPage: 1,
          perPageOptions: [8,20],
          total: 0
        },



      }
    },

    computed: {
      ...mapState({
        patient_card: state => state.patient_card,
        patient_card_disabled: state => state.patient_card_disabled,
        id_patient: state => state.id_patient,
        l_hpo: state => state.l_hpo,
      }),

    ...mapGetters({

      }),

      


      pagedData_hpo () {
        return this.l_hpo.slice(this.from_hpo, this.to_hpo)
      },

      hpo_data () {
        if (!this.searchQuery_hpo) {
          this.pagination_hpo.total = this.l_hpo.length
          return this.pagedData_hpo
        }
        let result = this.l_hpo
          .filter((row) => {
            let isIncluded = false
            let rowValue = row["hpo_term_name"].toString()
            if (rowValue.includes && rowValue.includes(this.searchQuery_hpo)) {
              isIncluded = true
            }
            return isIncluded
          })
        this.pagination_hpo.total = result.length
        return result.slice(this.from_hpo, this.to_hpo)
      },

      to_hpo () {
        let highBound = this.from_hpo + this.pagination_hpo.perPage
        if (this.total_hpo < highBound) {
          highBound = this.total_hpo
        }
        return highBound
      },

      from_hpo () {
        return this.pagination_hpo.perPage * (this.pagination_hpo.currentPage - 1)
      },

      total_hpo () {
        this.pagination_hpo.total = this.l_hpo.length
        return this.l_hpo.length
      },



    },

    methods: {
      handleLike (index, row, event) {
        event.stopImmediatePropagation();
      },

      handleCurrentChange_hpo(val) {
        if (val) {
          alert(val.hpo_id);
          // let skuplek = [];
          // for (let a of this.cufi.genes.values()) {
          //   skuplek.push(a);
          // }
          // for (let s of val.genelist) {
          //   if (!(skuplek.includes(s))) {
          //     skuplek.push(s);
          //   }
          // }
          // skuplek.sort();
          // let mykey = "genes";
          // let value = skuplek;
          // this.$store.commit('m_cufi', {mykey, value});
        }
        // this.a_notify("HPO was added into Patient Data");

      },

      handle_add_hpo(val) {
        if (val) {
          let xxx = {hpo_id: val.hpo_id, hpo_term_name: val.hpo_term_name};
          this.m_patient_card_hpo_add(xxx);
          // let skuplek = [];
          // for (let a of this.cufi.genes.values()) {
          //   skuplek.push(a);
          // }
          // for (let s of val.genelist) {
          //   if (!(skuplek.includes(s))) {
          //     skuplek.push(s);
          //   }
          // }
          // skuplek.sort();
          // let mykey = "genes";
          // let value = skuplek;
          // this.$store.commit('m_cufi', {mykey, value});
        }
        // this.a_notify("HPO was added into Patient Data");

      },

      handle_del_hpo(val) {
        if (val) {
          this.m_patient_card_hpo_del(val.hpo_id); 
        }
      },


      ...mapMutations({
        m_id_patient: 'm_id_patient',
        m_id_examination: 'm_id_examination',
        m_id_project: 'm_id_project',
        m_vars: 'm_vars',
        m_patient_card_hpo_add: 'm_patient_card_hpo_add',
        m_patient_card_hpo_del: 'm_patient_card_hpo_del',
      }),


      ...mapActions({
        a_patients: 'a_patients',
        a_examinations: 'a_examinations',
        a_notify: 'a_notify',

      }),

      updateProfile () {
        alert('Your data: ' + JSON.stringify(this.user))
      },


    },




  }

</script>
<style>
  .bottom_margin_30 {
    margin-bottom: 30px;
  }

  .bottom_margin_10 {
    margin-bottom: 10px;
  }

  .top_margin_10 {
    margin-top: 10px;
  }

  .top_margin_30 {
    margin-top: 30px;
  }




</style>
